//
//
//
//
//
//
//
//

export default {
  name: 'BrowseHistory',
  props: {
    pageSize: { type: Number, default: 20 },
  },
  data() {
    return {
      jobList: [],
      currentPage: 1,
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.jobList);
    },
  },
  methods: {
    getUserBrowseHistory() {
      const payload = {
        current: this.currentPage,
        size: this.pageSize,
      };
      this.$api('getUserBrowseHistory', payload).then(data => {
        this.jobList = data.records;
      });
    },
  },
  mounted() {
    this.getUserBrowseHistory();
  },
};
